import { Link } from "react-router-dom";

export const LogoMark = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 56 56" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="tfsBlue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#3B82F6" />
        <stop offset="1" stopColor="#1D4ED8" />
      </linearGradient>
    </defs>
    <rect x="1.5" y="1.5" width="53" height="53" rx="12" fill="#0B132B" stroke="#24345A" strokeWidth="1.5" />
    {/* accent notch */}
    <path d="M38 6h9a3 3 0 0 1 3 3v9" stroke="url(#tfsBlue)" strokeWidth="2.5" strokeLinecap="round" />
    {/* T tower: top bar + stem */}
    <rect x="14" y="15" width="28" height="6" rx="3" fill="url(#tfsBlue)" />
    <rect x="24.5" y="15" width="7" height="27" rx="3.5" fill="#FFFFFF" />
    {/* floor lines (building/facilities motif) */}
    <rect x="17" y="29" width="22" height="4" rx="2" fill="url(#tfsBlue)" opacity="0.8" />
    <rect x="19.5" y="37" width="17" height="4" rx="2" fill="url(#tfsBlue)" opacity="0.5" />
  </svg>
);

export const BrandLogo = ({ variant = "header", className = "" }) => {
  const iconSize = variant === "footer" ? 52 : 44;
  return (
    <Link to="/" data-testid="nav-logo" aria-label="Total Facilities Services home" className={`flex items-center gap-3 group ${className}`}>
      <LogoMark size={iconSize} />
      <span className="leading-none">
        <span className={`block font-display font-extrabold text-white tracking-tight ${variant === "footer" ? "text-2xl" : "text-xl"}`}>
          TFS
        </span>
        <span className={`block uppercase text-slatetxt tracking-[0.24em] mt-1 ${variant === "footer" ? "text-[10px]" : "text-[9px]"}`}>
          Total&nbsp;Facilities&nbsp;Services
        </span>
      </span>
    </Link>
  );
};
